import React, {useState, useMemo} from "react";
import ReactTable from "react-table-v6"
import { IconButton, Tooltip, TextField, Checkbox } from '@material-ui/core';
import { Autocomplete  } from "@mui/material";
import { AddCircle, ArrowForward, RemoveCircle, ModeEdit, CheckCircle } from '@mui/icons-material';
import { useHistory } from "react-router-dom";

import 'react-table-v6/react-table.css'

const EquipmentList = (props) => {
    const [editMode, setEditMode] = useState(false)
    const [editRow, setEditRow] = useState(null)
    const [locationOptions, setLocationOptions] = useState(null)

    const locationTypes = [
        {
            name: 'Site',
            brick_location_type: 'site'
        },
        {
            name: 'Building',
            brick_location_type: 'building'
        },
        {
            name: 'Outdoor Area',
            brick_location_type: 'outdoor_area'
        },
        {
            name: 'Space',
            brick_location_type: 'space'
        },
        {
            name: 'Zone',
            brick_location_type: 'zone'
        },
    ]
    let history = useHistory();

    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const equipmentAddPath = useMemo(() => {
        const params = new URLSearchParams();
        if (props.siteId) {
            params.set("site_id", props.siteId);
        }
        if (props.buildingId) {
            params.set("building_id", props.buildingId);
        }
        if (props.spaceId) {
            params.set("space_id", props.spaceId);
        }
        if (props.zoneId) {
            params.set("zone_id", props.zoneId);
        }
        const search = params.toString()
        return { pathname: "/equipment/add", search };
    }, [props.siteId, props.buildingId, props.spaceId, props.zoneId])

    const submitChange = (equipment) => {
        console.log("Updating equipment")
        
        equipment.element_id = equipment.location.location_type + "_" + equipment.location.id
        equipment.product = null //Otherwise we get an error from the backend because we don't have all the guts of the product
        console.log(equipment)
		props.updateEquipment(equipment).then(() => {
		 	setEditRow(null)
		 	setEditMode(false)

		})
	}

    const getLocationOptions = (type) => {
        let options = []
        switch(type) {
            case 'site':
                setLocationOptions([{id: props.siteId, name: 'Current Site'}])
                break;
            case 'building':
                props.buildingOptions(props.siteId).then(response => {
                    options = response
                    setLocationOptions(response)
                })
                break;
            case 'zone':
                props.zoneOptions(props.siteId).then(response => {
                    options = response
                    setLocationOptions(response)
                })
                break;
            case 'space':
                props.spaceOptions(props.siteId).then (response => {
                    options = response
                    setLocationOptions(response)
                })
                break;
            default:
                setLocationOptions([])
        } 
        console.log(options)
        return options
    }

    const columns = [
        {
            Header: 'Location',
            accessor: 'location',
            style: editMode ? {} : {paddingTop: 15},
            Cell: p => {
                console.log("Location options")
                console.log(locationOptions)
                let locationType = locationTypes.find(o => p.value.location_type === o.brick_location_type) || {}
                let locationValue = locationOptions && locationOptions.find(o => p.value.location_type === "site" ? true : p.value.name === o.name) || {}
                return editMode && (!editRow || (editRow && editRow.equipment_id === p.original.equipment_id)) ?
                    <div style={{display: "inline-flex", alignItems: "center"}}>
                        <Autocomplete
                            disablePortal
                            id="locationTypes"
                            width={150}
                            options={locationTypes}
                            getOptionLabel={option => option.name || ''}
                            style={{ width: "150px" }}
                            defaultValue={locationType}
                            isOptionEqualToValue={(option, value) => option.brick_location_type === value.brick_location_type}
                            renderInput={(params) => <TextField {...params} label="Area" variant="outlined" size="small" />}
                            groupBy={(option) => option.parent}
                            onChange={(event, newValue) => {
                                let currentEquipment = Object.assign({}, editRow);
                                currentEquipment.location.location_type = newValue.brick_location_type;
                                getLocationOptions(newValue.brick_location_type);
                                setEditRow(currentEquipment);
                            }}
                        />
                        {
                            locationOptions && <Autocomplete
                            disablePortal
                            id="locationOptions"
                            width={200}
                            options={locationOptions}
                            getOptionLabel={option => option.name || ''}
                            style={{ width: "200px" }}
                            defaultValue={locationValue}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            renderInput={(params) => <TextField {...params} label="Location" variant="outlined" size="small" />}
                            groupBy={(option) => option.parent}
                            onChange={(event, newValue) => {
                                let currentEquipment = Object.assign({}, editRow);
                                currentEquipment.location.id = newValue.id;
                                setEditRow(currentEquipment);
                            }}
                        />
                        }

                    </div>

                : p.value && p.value.name
            },
            show: width > 1000
        },
        {
            Header: 'Name',
            accessor: 'name',
            style: editMode ? {} : {paddingTop: 15},
            width: 250,
            Cell: p => {
				return editMode && (!editRow || (editRow && editRow.equipment_id === p.original.equipment_id)) ?
				<TextField defaultValue={p.value} variant="outlined" size="small"
					onBlur={(e) => {
						let space =Object.assign({}, editRow)
						space.name = e.target.value;
						setEditRow(space)
					}}/> : p.value 
			}
        },
        {
            Header: 'System',
            accessor: 'system',
            style: editMode ? {} : {paddingTop: 15},
            width: 225,
            Cell: p => {
                let currentValue = props.brickSystems.find(t => t.brick_system_type === p.value)
                return editMode && (editRow && editRow.equipment_id === p.original.equipment_id) ? (
                    <Autocomplete
                        disablePortal
                        id="systemOptions"
                        width={200}
                        options={props.brickSystems || []}
                        getOptionLabel={option => option.name}
                        style={{ width: "200px" }}
                        defaultValue={currentValue}
                        isOptionEqualToValue={(option, value) => option.brick_system_type === value.brick_system_type}
                        renderInput={(params) => <TextField {...params} label="System" variant="outlined" size="small" />}
                        groupBy={(option) => option.parent}
                        onChange={(event, newValue) => {
                            let currentEquipment = Object.assign({}, editRow);
                            currentEquipment.system = newValue.brick_system_type;
                            setEditRow(currentEquipment);
                        }}
                    />
              ) : currentValue && currentValue.name
          },
            show: width > 1000
        },
        {
            Header: 'Type',
            accessor: 'type',
            style: editMode ? {} : {paddingTop: 15},
            width: 225,
            Cell: p => {
                let currentValue = props.brickTypes.find(t => t.brick_equipment_type === p.value)
                return editMode && (editRow && editRow.equipment_id === p.original.equipment_id) ? (
                    <Autocomplete
                    disablePortal
                    id="typeOptions"
                    width={200}
                    options={props.brickTypes || []}
                    getOptionLabel={option => option.name}
                    value={props.brickTypes.find(t => t.brick_equipment_type === p.original.type)}
                    isOptionEqualToValue={(option, value) => option.brick_equipment_type === value.brick_equipment_type}
                    style={{ width: "200px" }}
                    renderInput={(params) => <TextField {...params} label="Type" variant="outlined" size="small" />}
                    groupBy={(option) => option.parent}
                    onChange={(event, newValue) => {
                        let currentEquipment = Object.assign({}, editRow);
                        currentEquipment.type = newValue.brick_equipment_type;
                        setEditRow(currentEquipment);
                    }}
                />
              ) : currentValue && currentValue.name
          },
        },
        {
            Header: 'Product',
            accessor: 'product',
            style: editMode ? {} : {paddingTop: 15},
            Cell: p => {
                let selectedProduct = editRow && editRow.product && props.productOptions.find(t => t.id == editRow.product.product_id)
                console.log("SelectedProduct")
                console.log(selectedProduct)
                return  editMode && (editRow && editRow.equipment_id === p.original.equipment_id) ? (
                    <Autocomplete
                        disablePortal
                        id="product"
                        size={"small"}
                        options={props.productOptions}
                        getOptionLabel={option => option.label || ''}
                        value={editRow.product ? selectedProduct : {}}
                        renderInput={(params) => <TextField {...params} label="Product" variant="outlined" />}
                        onChange={(event, newValue) => {
                            let currentEquipment = Object.assign({}, editRow);
                            currentEquipment.product_id = newValue.id;
                            currentEquipment.product = {
                                product_id: newValue.id
                            }
                            setEditRow(currentEquipment);
                        }}
                    /> 
                    ) : (p && p.value) ? 
                        p.value.company === "Unknown" ? p.value.model : p.value.company + " " + p.value.model
                    :  null;

            },
            show: width > 1000
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: p => {
                let edit = editMode && (editRow && editRow.equipment_id === p.original.equipment_id)
                return <Tooltip title="Is Active">
                        <Checkbox
                            variant="contained"
                            color="primary"
                            aria-label={"Is Active"}
                            size={"small"}
                            checked={edit ? editRow.value : p.value}
                            disabled={!edit}
                            onChange={(event, newValue) => {
                                let currentEquipment = Object.assign({}, editRow);
                                currentEquipment.is_active = !currentEquipment.is_active
                                setEditRow(currentEquipment);
                            }}
                        >
                        </Checkbox>
                    </Tooltip>
            },
            width: 75
        },

        {
            Header: '',
            accessor: 'equipment_id',
            Cell: p => {
                let link = "/equipment/" + p.value

                return <div>
                {
                   editMode && (editRow && editRow.equipment_id === p.original.equipment_id)?
                   <Tooltip title="Edit">
                       <IconButton
                           variant="contained"
                           color="primary"
                           aria-label={"Edit Equipment" }
                           size={"small"}
                           onClick={() => {

                               submitChange(editRow)
                           }}>
                               <CheckCircle />
                       </IconButton>
                   </Tooltip> : null
               }
               <Tooltip title="Edit">
                   <IconButton
                       variant="contained"
                       color="primary"
                       aria-label={"Edit Equipment" }
                       size={"small"}
                       onClick={() => {
                           console.log(p.original)
                           setEditRow(!editMode ? p.original : null)
                           getLocationOptions(p.original.location.location_type)
                           setEditMode(!editMode)
                       }}>
                           <ModeEdit />
                   </IconButton>
               </Tooltip>
               <IconButton
                       variant="contained"
                       color="primary"
                       aria-label={"View equipment detail" }
                       size={"small"}
                       onClick={() => {
                                   history.push(link)
                           }}>
                       <ArrowForward />
                   </IconButton>
               </div>
            },
            width: 100
        },
    ]

        return (
            <div className="equipment-list">
                <div className="space-add-mode">
                { props.equipment && props.equipment.length > 0 ?
                    <Tooltip title="Add Additional Equipment">
                        <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Add equipment" }

                                    onClick={() => {
                                        history.push(equipmentAddPath);
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                        </IconButton>
                    </Tooltip>
                : null}
                </div>
                <div className="section-header">Equipment </div>
                { props.equipment && props.equipment.length > 0 ?
                    <div className="point-list-table">
                        <ReactTable key={(props.equipment && props.equipment.length) || 0}
                            data={props.equipment || []}
                            columns={columns}
                            minRows={0}
                            defaultPageSize={10}
                            showPagination={props.equipment && props.equipment.length > 10}
                        />
                    </div>
                :
                <div className="bulk_add_prompt">
                    <IconButton
                                    variant="contained"
                                    color="primary"
                                    aria-label={"Add equipment" }

                                    onClick={() => {
                                        history.push(equipmentAddPath);
                                }}>
                            <AddCircle style={{fill: "#00b088", background: "white"}}/>
                    </IconButton>
                    There is currently no equipment configured.  Add some now!
                </div>
                }


            </div>



        )
}

export default EquipmentList;
